<template>
  <div class="app">
    <h1>Elo Calculator</h1>
    <h2>Calculate your new rating</h2>
    <div class="myStats">
      <label for="rating">Current rating</label>
      <input type="number" id="rating" @change="saveValues()" v-model="myRating" min="0" max="4000" placeholder="Rating">
      <label for="rating">Score</label>
      <input type="number" v-model="score" min="0" step="0.5" v-bind:max="this.opponents.length" placeholder="Score">
      <label for="rating">K-factor</label>
      <select v-model="kFactor">
        <option>10</option>
        <option>20</option>
        <option>30</option>
        <option>40</option>
      </select>
    </div>
    <form class="addOpponent" v-on:submit="addOpponent">
      <input class="addOpponent" type="number" v-model="newOpponent.rating" min="800" max="3000" placeholder="Add new opponent rating">
    </form>

    <div class="opponents" v-if="this.opponents.length > 0">

    <table>
      <tr>
        <th>Rating</th>
        <th>Expected result</th> 
      </tr>
      <tr v-for="opponent in opponents">
        <td>{{ opponent.rating }}</td>
        <td>{{ opponent.expectation.toFixed(2)}}</td> 
        <td> <button
          class="btn opponent-remove"
          v-on:click="removeOpponent(opponent)">
          <i>&times;</i>
      </button></td>
      </tr>
    </table>
     <button
          class="btn" style="margin-bottom: 10px;"
          v-on:click="clearOpponents()">
          Clear opponents
        </button>
    </div>

     <div class="results" v-if="this.myRating > 800 && this.myRating <= 3000">
      <h2>Expected result</h2>
      <p>
        {{totalExpectation.toFixed(2)}}
      </p>
     
      <h2>New rating</h2>
      <p>
        {{newRating.toFixed(1)}} 
        <span style="color: green;" v-if="newRating - this.myRating >= 0">(+{{(newRating - this.myRating).toFixed(1)}})</span>
        <span style="color: red;" v-if="newRating - this.myRating < 0">({{(newRating - this.myRating).toFixed(1)}})</span>
      </p>
    </div>

  </div>
</template>


<script>

  import EloRating from 'elo-rating'

  const OPPONENT_STORAGE_KEY = 'elo-storage';
  const MY_RATING_STORAGE_KEY = 'my-rating-storage';
  const K_FACTOR_STORAGE_KEY = 'k-factor-storage';
  const SCORE_STORAGE_KEY = 'score-storage';

  export default {
    name: 'opponents',
    data() {
      return {
        myRating: 2000,
        kFactor: 30,
        score: 0,
        newOpponent: {},
        opponents: []
      }
    },
    created () {
      this.score = JSON.parse(localStorage.getItem(SCORE_STORAGE_KEY) || 0);
      this.myRating = JSON.parse(localStorage.getItem(MY_RATING_STORAGE_KEY) || 2000);
      this.kFactor = JSON.parse(localStorage.getItem(K_FACTOR_STORAGE_KEY) || 30);
      this.opponents = JSON.parse(localStorage.getItem(OPPONENT_STORAGE_KEY) || '[]');
    },
    computed: {
      totalExpectation: function() {
        let total = 0
        Object.entries(this.opponents).forEach(([key, opponent]) => {
          total += opponent.expectation;
        });
        return total;
      },
      newRating: function () {
        if(this.myRating >= 800 && this.myRating <= 3000) {
          return Number(this.myRating) + ((this.score - this.totalExpectation) * this.kFactor)
        }
      }
    },
    methods: {
      saveValues: function() {
        console.log("save values");
        localStorage.setItem(SCORE_STORAGE_KEY, JSON.stringify(this.score));
        localStorage.setItem(MY_RATING_STORAGE_KEY, JSON.stringify(this.myRating));
        localStorage.setItem(K_FACTOR_STORAGE_KEY, JSON.stringify(this.kFactor));
        Object.entries(this.opponents).forEach(([key, opponent]) => {
          opponent.expectation = EloRating.expected(this.myRating, opponent.rating)
        });
        localStorage.setItem(OPPONENT_STORAGE_KEY, JSON.stringify(this.opponents));
      },
      clearOpponents: function() {
        this.opponents = []
        localStorage.setItem(OPPONENT_STORAGE_KEY, JSON.stringify(this.opponents));
        this.score = 0;
        this.saveValues();
      },
      addOpponent: function(e) {
        this.opponents.push({
          rating: this.newOpponent.rating,
          expectation: EloRating.expected(this.myRating, this.newOpponent.rating)
        });
        console.log(EloRating.expected(this.myRating, this.newOpponent.rating));
        localStorage.setItem(OPPONENT_STORAGE_KEY, JSON.stringify(this.opponents));
        this.newOpponent.rating = ""
        e.preventDefault();
        this.saveValues();
      },
      removeOpponent: function(opponent) {
        this.opponents.splice(this.opponents.indexOf(opponent), 1);
        localStorage.setItem(OPPONENT_STORAGE_KEY, JSON.stringify(this.opponents));
        if(this.score > this.opponents.length) {
          this.score = this.opponents.length;
        }
        this.saveValues();
      }
    }
  }
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

*, *:before, *:after {
  box-sizing: border-box;
}

.menu a, .menu a:hover, .menu a:active, .menu a:visited { color: white; }

a, a:hover, a:active, a:visited { color: #3498db; }

.results p {
  text-align: center;
}

.myStats {
  width: 90%;
}

.myStats input{
  width: 100px;
  height: 40px;
  text-align: center;
  font-size: 16pt;
  float: right;
}

.myStats select {
  width: 100px;
  height: 40px;
  text-align: center;
  font-size: 16pt;
  float: right;
}

.addOpponent {
  width: 90%;
  height: 40px;
  margin-top: 10px;
  margin-bottom: 20px;
}

.addOpponent input{
  text-align: center;

  font-size: 16pt;
}

.opponents {
  width: 100%;
}

.opponents table {
  width: 100%;
}

label {
    text-align: right;
    clear: both;
    float:left;
    margin-right:15px;
    line-height: 40px;
}

html {
  background: #3498db;
}

body {
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  font-family: "Source Sans Pro", sans-serif;
}

.app {
  width: 400px;
  min-height: 50vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  border-radius: 1em;
  background: #fff;
  overflow: hidden;
}

button {
  font-size: 14px;
  margin: 0 .5em;
  border-radius: 2em;
  padding: 0.75em 1.5em;
  cursor: pointer;
  background: none;
  color: #2980b9;
  border: 1px solid;
  letter-spacing: 1px;
  color: #2980b9;
  border: #2980b9 1px solid;
}

.opponent-remove {
  padding: 0;
  width: 2em;
  height: 2em;
}

</style>



// WEBPACK FOOTER //
// src/components/Opponents.vue?567618ab